import appPages from "../../../appPages";
import {isWeb, navigate} from "../../../helpers/utils";

const THRESHOLD_APP_REFRESH_MS = 30 * 1000;

const sendFlagsToApp = (settings = {}) => {
  if (settings && window.embeddedLogin) {
    if (window.embeddedLogin.showDebugTools) window.embeddedLogin.showDebugTools(settings.native_debugging_tools);

    if (settings.native_run_on_startup) {
      if (window.embeddedLogin.enableStartupRun) window.embeddedLogin.enableStartupRun();
    }
    else {
      if (window.embeddedLogin.disableStartupRun) window.embeddedLogin.disableStartupRun();
    }
  }
};

const initFlags = (controller) => {
  if (window.embeddedLogin && window.embeddedConsoleInitialized == null) {
    console.log("Configuring app flags");

    const {testing_preferences} = controller.state?.settings || {};
    if (testing_preferences) {
      console.log("Configured app flags");

      window.embeddedConsoleInitialized = true;
      sendFlagsToApp(testing_preferences);
    }
  }
}

const configureCallback = (controller, navigation) => {
  console.log("Configuring callback...");
  if (window.embeddedLogin) {
    console.log("Configuring tasks");

    window.nativeTimerTask = function (data) {
      if (
          controller.apiService != null &&
          controller.state != null &&
          controller.state.currentUser != null &&
          controller.state.accessToken != null
          //&& controller.state?.settings?.integrations && controller.state?.settings?.integrations[data.os]
      ) {
        try {
          controller.apiService.deviceData(JSON.stringify(data));
        } catch (e) {
          console.log(e);
        }
      }
    };

    window.embeddedLoginCallback = (params) => {
      console.log("Login callback");

      const user = params.email;
      const token = params.token;
      const picture = params.picture;

      if (user && token && (controller.state.currentUser != user || controller.state.accessToken != token || controller.state.picture != picture)) {
        console.log("Restored logged in user " + user + " " + token + " " + picture);
        controller.apiService.sendNotification("login", {user: user, token: token, picture: picture});
        controller.setState({
          currentUser: user,
          accessToken: token,
          picture: picture,
        });

        console.log("Refresh integrations");
        controller.refreshIntegrations(true);
        console.log("Navigate");
        if (controller.hasNavigation()) {
          navigation.navigate("mana");
        } else {
          navigate(controller, "rn:home_card");
        }
      }
    };

    window.embeddedAppActivate = (params) => {
      console.log("Native app activate");
      var now = +new Date();
      if (window.lastAppActivate == null || now - window.lastAppActivate > THRESHOLD_APP_REFRESH_MS) {
        window.lastAppActivate = +new Date();
        console.log("Refresh");
        controller.getItems();
      }
    }

    window.embeddedCalendarLoginCallback = (params) => {
      console.log("Calendar login callback");

      const user = params.email;
      const token = params.token;
      const redirectUrl = params.redir;

      const action = {
        action: "save",
        target: "token",
        account: "", //user,
        code: token,
        redir: redirectUrl,
        device: "web"
      };

      //console.log(action);
      controller.apiService.cardAction(action).then((reply) => {
        const account = reply.id;
        if (account && token) {
          console.log("Navigate");
          if (window.embeddedAuthorizeCalendarCallback) {
            window.embeddedAuthorizeCalendarCallback("google", null, account);
            window.embeddedAuthorizeCalendarCallback = null;
          } else {
            navigate(controller, appPages.integrationsCalendar, "changePage", {
              email: account,
            });
          }
        }
      });
    };
  }
};

const getOptions = () => {
  return window.embeddedLogin ? [
    {
      id: 91,
      name: "Show Debugging Tools",
      value: "native_debugging_tools",
      icon: null,
      hasToggle: true,
    },
    {
      id: 92,
      name: "Run On Startup",
      value: "native_run_on_startup",
      icon: null,
      hasToggle: true,
    },
  ] : [];
};

const NativeHelper = {
  sendFlagsToApp,
  configureCallback,
  initFlags,
  getOptions
};

export default NativeHelper;
